import Alpine from "alpinejs";
import persist from "@alpinejs/persist";

Alpine.plugin(persist);

export { Alpine };
